// Center.tsx
import React, { type ReactNode, type HTMLAttributes } from "react";
import "./center.css";

interface CenterProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  // Мы наследуем HTMLAttributes, поэтому className, style, id и прочие
  // уже включены в типы пропсов автоматически.
}

export const Center = ({ children }: CenterProps) => {
  return <div className="center">{children}</div>;
};
